/* eslint-disable promise/param-names */
import Vue from 'vue'
import axios from 'axios'
import { GET_EMPLOYEES_ERROR, GET_EMPLOYEES_REQUEST, GET_EMPLOYEES_SUCCESS } from './actiontypes';
import userApi from '../../_services/api/user';

const state = {
  categories: {},
  status: '',
  errors: [],
  hasLoadedOnce: false,
};

const getters = {
  documentations: state => state.documentations,
};

const actions = {
  [GET_EMPLOYEES_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit(GET_EMPLOYEES_REQUEST);
      userApi.getEmployees(payload)
        .then((response) => {
          if (response.success === true) {
            commit(GET_EMPLOYEES_SUCCESS, response.data);
            resolve(response);
          } else {
            commit(GET_EMPLOYEES_ERROR, response);
            reject(response.error);
          }
        })
        .catch((error) => {
          commit(GET_EMPLOYEES_ERROR, error);
          reject(error);
        });
    });
  },
};

const mutations = {
  [GET_EMPLOYEES_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [GET_EMPLOYEES_SUCCESS]: (state, response) => {
    state.status = 'success';
    state.token = response.token;
    state.hasLoadedOnce = true;
    Vue.set(state, 'categories', response.categories);
  },
  [GET_EMPLOYEES_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
